import Assessment from "@landingClient/pages/Assessment";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/assessments/$assessmentId/")({
  component: Assessment,
});
